import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { ProductContextModel } from "@insite/client-framework/Components/ProductContext";
import { CartLineModel } from "@insite/client-framework/Types/ApiModels";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Img, { ImgProps } from "@insite/mobius/Img";
import { LazyImageProps } from "@insite/mobius/LazyImage";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    product: CartLineModel | ProductContextModel;
    onClick?: React.EventHandler<React.MouseEvent>;
    extendedStyles?: ProductImageStyles;
    showSmallImage?: boolean;
}

type Props = OwnProps;

export interface ProductImageStyles {
    linkWrappingImage?: ClickablePresentationProps;
    /**
     * @deprecated Use img instead
     */
    image?: LazyImageProps;
    img?: ImgProps;
}

export const productImageStyles: ProductImageStyles = {
    linkWrappingImage: {
        css: css`
            width: 100%;
            padding-bottom: 100%;
            position: relative;
        `,
    },
    image: {
        css: css`
            img {
                height: 100%;
            }
        `,
    },
    img: {
        css: css`
            height: auto;
            width: auto;
            max-height: 100%;
            margin: auto;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            position: absolute;
            display: block;
            max-width: 100%;
        `,
    },
};

const ProductImage = ({ product, onClick, extendedStyles, showSmallImage }: Props) => {
    const [styles] = useState(() => mergeToNew(productImageStyles, extendedStyles));

    let altText = "product" in product ? product.product.imageAltText : product.altText;
    if (!altText || altText === "") {
        altText = "product" in product ? product.product.productTitle : product.productName;
    }

    const imagePath =
        "product" in product
            ? showSmallImage
                ? product.product.smallImagePath || product.product.mediumImagePath
                : product.product.mediumImagePath || product.product.smallImagePath
            : product.smallImagePath;

    const productDetailPath = "product" in product ? product.productInfo.productDetailPath : product.productUri;
    // const productDetailPath =
    // ("product" in product ? product.productInfo.productDetailPath : product.productUri) ||
    // ("product" in product
    //     ? showSmallImage
    //         ? product.product.smallImagePath || product.product.mediumImagePath
    //         : product.product.mediumImagePath || product.product.smallImagePath
    //     : product.smallImagePath);
    const canonicalUrl = "product" in product ? product?.product?.canonicalUrl : undefined;
    const loading = product.idx === undefined ? "lazy" : product.idx < 3 ? "eager" : "lazy";

    return (
        <>
            {productDetailPath ? (
                <Clickable
                    {...styles.linkWrappingImage}
                    href={canonicalUrl || productDetailPath}
                    onClick={onClick}
                    data-test-selector="productImage"
                >
                    <Img {...styles.img} loading={loading} decoding="async" src={imagePath} altText={altText} />
                </Clickable>
            ) : (
                <Img {...styles.img} loading={loading} decoding="async" src={imagePath} altText={altText} />
            )}
        </>
    );
};

export default ProductImage;
